import { ISagaModule } from 'redux-dynamic-modules-saga';
import subscribeSaga from './subscribeSaga';
import consumerReducer from './reducer';
import { reduxModuleLoaded } from './actions';
import { tierConsumerReduxKey } from './constants';

export function getModule(): ISagaModule<{}> {
  return {
    id: 'tierConsumer',
    reducerMap: {
      [tierConsumerReduxKey as string]: consumerReducer,
    },
    sagas: [subscribeSaga],
    initialActions: [reduxModuleLoaded()],
    retained: true,
  };
}
